// extracted by mini-css-extract-plugin
module.exports = {"root":"cEgIAH","title":"rXOv1H","top-divider":"EkF8XV","topDivider":"EkF8XV","bottom-divider":"xQDcuS","bottomDivider":"xQDcuS"};